// (c) Copyright Ascensio System SIA 2009-2025
//
// This program is a free software product.
// You can redistribute it and/or modify it under the terms
// of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
// Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
// to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
// any third-party rights.
//
// This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
// of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
// the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
//
// You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
//
// The  interactive user interfaces in modified source and object code versions of the Program must
// display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
//
// Pursuant to Section 7(b) of the License you must retain the original Product logo when
// distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
// trademark law for use of our trademarks.
//
// All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
// content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
// International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode

export const enum ScopeType {
  read = "read",
  write = "write",
  openid = "openid",
}

export const enum ScopeGroup {
  files = "files",
  accounts = "accounts",
  contacts = "contacts",
  profiles = "profiles",
  rooms = "rooms",
  openid = "openid",
}

export const enum AuthenticationMethod {
  none = "none",
  client_secret_post = "client_secret_post",
}

/**
 * Enum for employee activation status.
 * @readonly
 */
export const enum EmployeeActivationStatus {
  NotActivated = 0,
  Activated = 1,
  Pending = 2,
  AutoGenerated = 4,
}
/**
 * Enum for employee status.
 * @readonly
 */
export enum EmployeeStatus {
  Active = 1,
  Disabled = 2,
  Pending = 4, // NEW STATUS from server
}
/**
 * Enum for employee type.
 * @readonly
 */
export enum EmployeeType {
  RoomAdmin = 1,
  Guest = 2,
  Admin = 3,
  User = 4,
  Owner = "owner",
}
/**
 * Enum for employee type.
 * @readonly
 */
export enum EmployeeTypeString {
  RoomAdmin = "roomAdmin",
  Guest = "guest",
  Admin = "admin",
  User = "user",
  Owner = "owner",
}
/**
 * Enum for user payments type.
 * @readonly
 */
export enum PaymentsType {
  Paid = "0",
  Free = "1",
}
/**
 * Enum for account login type.
 * @readonly
 */
export enum AccountLoginType {
  SSO = "0",
  LDAP = "1",
  STANDART = "2",
}
/**
 * Enum for files selector filter.
 * @readonly
 */
export enum ApplyFilterOption {
  All = "All",
  Files = "Files",
  Folder = "Folder",
}
/**
 * Enum for files selector filter.
 * @readonly
 */
export const enum FilesSelectorFilterTypes {
  DOCX = "DOCX",
  PDF = "PDF",
  IMG = "IMG",
  GZ = "GZ",
  DOCXF = "DOCXF",
  XLSX = "XLSX",
  ALL = "ALL",
  BackupOnly = "BackupOnly",
}
/**
 * Enum for filter subject.
 * @readonly
 */
export const enum FilterSubject {
  Owner = "0",
  Member = "1",
}
/**
 * Enum for filter type.
 * @readonly
 */
export enum FilterType {
  None = 0,
  FilesOnly = 1,
  FoldersOnly = 2,
  DocumentsOnly = 3,
  PresentationsOnly = 4,
  SpreadsheetsOnly = 5,
  ImagesOnly = 7,
  ByUser = 8,
  ByDepartment = 9,
  ArchiveOnly = 10,
  ByExtension = 11,
  MediaOnly = 12,
  FillingFormsRooms = 13,
  EditingRooms = 14,
  ReviewRooms = 15,
  ReadOnlyRooms = 16,
  CustomRooms = 17,
  PublicRooms = 20,
  FormRooms = 21,
  Pdf = 22,
  PDFForm = 23,
  DiagramsOnly = 25,
}

/**
 * Enum for filter location.
 * @readonly
 */
export const enum FilterLocation {
  Rooms = 1,
  Documents = 2,
  Link = 3,
}

/**
 * Enum for file type.
 * @readonly
 */
export const enum FileType {
  Unknown = 0,
  Archive = 1,
  Video = 2,
  Audio = 3,
  Image = 4,
  Spreadsheet = 5,
  Presentation = 6,
  Document = 7,
  OFormTemplate = 8,
  OForm = 9,
  PDF = 10,
  Diagram = 11,
}

/**
 * Enum for room provider type.
 * @readonly
 */
export const enum RoomsProviderType {
  Box = 1,
  DropboxV2 = 2,
  GoogleDrive = 3,
  kDrive = 4,
  OneDrive = 5,
  SharePoint = 6,
  WebDav = 7,
  Yandex = 8,
  Storage = 9,
}

/**
 * Enum for room search area.
 * @readonly
 */
export const enum RoomSearchArea {
  Any = "Any",
  Active = "Active",
  Archive = "Archive",
  Templates = "Templates",
  AIAgents = "AiAgents",
}
/**
 * Enum for file action.
 * @readonly
 */
export const enum FileAction {
  Create = 0,
  Rename = 1,
  RestoreVersion = 2,
}

/**
 * @readonly
 */

export const enum PageType {
  account = "account",
  customization = "customization",
  security = "security",
  backup = "backup",
  restore = "restore",
  integration = "integration",
  developerTools = "developerTools",
  portalDeletion = "portalDeletion",
  payments = "payments",
  bonus = "bonus",
  dataImport = "dataImport",
  storageManagement = "storageManagement",
  flows = "flows",
  services = "services",
  groups = "groups",
  guests = "guests",
  aiSettings = "aiSettings",
}

/**
 * Enum for root folders type.
 * @readonly
 */
export const enum FolderType {
  DEFAULT = 0,
  COMMON = 1,
  BUNCH = 2,
  TRASH = 3,
  USER = 5,
  SHARE = 6,
  Projects = 8,
  Favorites = 10,
  Recent = 11,
  Templates = 12,
  Privacy = 13,
  Rooms = 14,
  FormRoom = 15,
  EditingRoom = 16,
  ReviewRoom = 17,
  ReadOnlyRoom = 18,
  CustomRoom = 19,
  Archive = 20,
  PublicRoom = 22,
  Done = 25,
  InProgress = 26,
  SubFolderDone = 27,
  SubFolderInProgress = 28,
  VirtualDataRoom = 29,
  RoomTemplates = 30,
  AIAgent = 31,
  Knowledge = 32,
  ResultStorage = 33,
  AIAgents = 34,
}

export const enum ShareAccessRights {
  None = 0,
  FullAccess = 1,
  ReadOnly = 2,
  DenyAccess = 3,
  Varies = 4,
  Review = 5,
  Comment = 6,
  FormFilling = 7,
  CustomFilter = 8,
  RoomManager = 9,
  Editing = 10,
  Collaborator = 11,
}

export const enum ShareRights {
  None = "None",
  ReadWrite = "ReadWrite",
  Read = "Read",
  Restrict = "Restrict",
  Varies = "Varies",
  Review = "Review",
  Comment = "Comment",
  FillForms = "FillForms",
  CustomFilter = "CustomFilter",
  RoomManager = "RoomManager",
  Editing = "Editing",
  ContentCreator = "ContentCreator",
}

export const enum ConflictResolveType {
  Skip = 0,
  Overwrite = 1,
  Duplicate = 2,
}

/**
 * Enum for third-party storages.
 * @readonly
 */
export const enum ThirdPartyStorages {
  GoogleId = "googlecloud",
  RackspaceId = "rackspace",
  SelectelId = "selectel",
  AmazonId = "s3",
}
/**
 * Enum for backup types.
 * @readonly
 */
export const enum BackupStorageType {
  DocumentModuleType = 0,
  ResourcesModuleType = 1,
  LocalFileModuleType = 3,
  TemporaryModuleType = 4,
  StorageModuleType = 5,
}

export const enum AutoBackupPeriod {
  EveryDayType = 0,
  EveryWeekType = 1,
  EveryMonthType = 2,
}

/**
 * Enum for Tenant trusted domains on registration.
 * @readonly
 */
export const enum TenantTrustedDomainsType {
  None = 0,
  Custom = 1,
  All = 2,
}

/**
 * Enum for file status.
 * @readonly
 */
export const enum FileStatus {
  None = 0,
  IsEditing = 1,
  IsNew = 2,
  IsConverting = 4,
  IsOriginal = 8,
  IsEditingAlone = 16,
  IsFavorite = 32,
  IsTemplate = 64,
  IsFillFormDraft = 128,
}

/**
 * Enum for tenant status.
 * @readonly
 */
export const enum TenantStatus {
  PortalDeactivate = 1,
  PortalRestore = 4,
  EncryptionProcess = 6,
}

/**
 * Enum for theme keys.
 * @readonly
 */
export const enum ThemeKeys {
  Base = "0",
  BaseStr = "Base",
  Dark = "1",
  DarkStr = "Dark",
  System = "2",
  SystemStr = "System",
}

/**
 * Enum for global events.
 * @readonly
 */
export const enum Events {
  CREATE = "create",
  RENAME = "rename",
  ROOM_CREATE = "create_room",
  ROOM_EDIT = "edit_room",
  GROUP_CREATE = "create_group",
  GROUP_EDIT = "edit_group",
  CHANGE_COLUMN = "change_column",
  CHANGE_USER_TYPE = "change_user_type",
  CHANGE_QUOTA = "change_quota",
  CREATE_PLUGIN_FILE = "create_plugin_file",
  CREATE_PDF_FORM_FILE = "create_pdf_form_file",
  SAVE_AS_TEMPLATE = "save_as_template",
  Share_PDF_Form = "share_pdf_form",
  AGENT_CREATE = "create_agent",
  AGENT_EDIT = "edit_agent",
}

/**
 * Enum for feed action types.
 * @readonly
 */
export const enum FeedActionTypes {
  Create = 0,
  Update = 1,
  Rename = 2,
  Move = 3,
  Delete = 4,
}

/**
 * Enum for feed item types.
 * @readonly
 */
export const enum FeedItemTypes {
  File = "file",
  Folder = "folder",
  Room = "room",
  Tag = "tag",
  User = "sharedRoom",
}

/**
 * Enum for theme keys.
 * @readonly
 */
export const enum TariffState {
  Trial = 0,
  Paid = 1,
  Delay = 2,
  NotPaid = 3,
}

/**
 * Enum for theme keys.
 * @readonly
 */
export const enum PortalFeaturesLimitations {
  Limitless = -1,
  Unavailable = 0,
}

/**
 * Enum for payment method status.
 * @readonly
 */
export const enum PaymentMethodStatus {
  None = 0,
  Set = 1,
  Expired = 2,
}

/**
 * Enum for quota state.
 * @readonly
 */
export const enum QuotaState {
  Active = 0,
  Overdue = 1,
}

/**
 * Enum for notifications.
 * @readonly
 */
export const enum NotificationsType {
  Badges = 0,
  RoomsActivity = 1,
  DailyFeed = 2,
  UsefulTips = 3,
}

export const enum FilterGroups {
  filterType = "filter-filterType",
  filterAuthor = "filter-author",
  filterSharedBy = "filter-sharedBy",
  filterFolders = "filter-folders",
  filterRoom = "filter-room",
  filterContent = "filter-withContent",
  filterQuota = "filter-quota",
  roomFilterProviderType = "filter-provider-type",
  roomFilterType = "filter-type",
  roomFilterSubject = "filter-subject",
  roomFilterOwner = "filter-owner",
  roomFilterTags = "filter-tags",
  roomFilterFolders = "filter-withSubfolders",
  roomFilterContent = "filter-content",
  filterGroup = "filter-group",
  groupsFilterMember = "filter-group-member",
  groupsFilterManager = "filter-group-manager",

  filterLoginType = "filter-login-type",
  filterStatus = "filter-status",
  filterAccount = "filter-account",
  filterOther = "filter-other",
  filterInviter = "filter-inviter",
  filterLocation = "filter-location",
}

export const enum FilterKeys {
  withSubfolders = "withSubfolders",
  excludeSubfolders = "excludeSubfolders",
  withContent = "withContent",
  me = "me",
  other = "other",
  user = "user",
  withoutGroup = "withoutGroup",
  selectedGroup = "selectedGroup",
  byManager = "byManager",
  customQuota = "2",
  defaultQuota = "1",
}

export const enum IndexedDBStores {
  images = "images",
}

export const enum FilterSelectorTypes {
  people = "people-selector",
  rooms = "rooms-selector",
  groups = "groups-selector",
}

export enum DeviceType {
  mobile = "mobile",
  tablet = "tablet",
  desktop = "desktop",
}

export const enum ParseErrorTypes {
  None = 0,
  EmptyRecipients = 1,
  IncorrectEmail = 2,
}

export const enum ButtonKeys {
  enter = "Enter",
  numpadEnter = "NumpadEnter",
  esc = "Escape",
  tab = "Tab",
}

export const enum ErrorKeys {
  LocalDomain = "LocalDomain",
  IncorrectDomain = "IncorrectDomain",
  DomainIpAddress = "DomainIpAddress",
  PunycodeDomain = "PunycodeDomain",
  PunycodeLocalPart = "PunycodeLocalPart",
  IncorrectLocalPart = "IncorrectLocalPart",
  SpacesInLocalPart = "SpacesInLocalPart",
  MaxLengthExceeded = "MaxLengthExceeded",
  IncorrectEmail = "IncorrectEmail",
  ManyEmails = "ManyEmails",
  EmptyEmail = "EmptyEmail",
}

export enum RoomsType {
  AIRoom = 9, // TODO: Restore when certs will be done
  PublicRoom = 6,
  FormRoom = 1,
  // FillingFormsRoom= 1, //TODO: Restore when certs will be done
  EditingRoom = 2,
  // ReviewRoom: 3, //TODO: Restore when certs will be done
  // ReadOnlyRoom: 4, //TODO: Restore when certs will be done
  VirtualDataRoom = 8,
  CustomRoom = 5,
}

export const enum RecaptchaType {
  Default = 0,
  AndroidV2 = 1,
  iOSV2 = 2,
  hCaptcha = 3,
}

export enum AccountsSearchArea {
  People = "0",
  Groups = "1",
  Any = "2",
}

export enum MembersSubjectType {
  User = 0,
  ExternalLink = 1,
  Group = 2,
  InvitationLink = 3,
  PrimaryExternalLink = 4,
}

/**
 * Enum for open url action.
 * @readonly
 */
export const enum UrlActionType {
  Download = 0,
  Link = 1,
}

export const enum WhiteLabelLogoType {
  LightSmall = 1,
  LoginPage = 2,
  Favicon = 3,
  DocsEditor = 4,
  DocsEditorEmbed = 5,
  LeftMenu = 6,
  AboutPage = 7,
  Notification = 8,
  SpreadsheetEditor = 9,
  SpreadsheetEditorEmbed = 10,
  PresentationEditor = 11,
  PresentationEditorEmbed = 12,
  PdfEditor = 13,
  PdfEditorEmbed = 14,
  DiagramEditor = 15,
  DiagramEditorEmbed = 16,
}

/**
 * Enum for files selector filter extended.
 * @readonly
 */
export const enum FilesSelectorExtendedFilterTypes {
  Folders = "Folders",
  Documents = "Documents",
  Presentations = "Presentations",
  Spreadsheets = "Spreadsheets",
  Images = "Images",
  Media = "Media",
  Archives = "Archives",
  AllFiles = "AllFiles",
  Forms = "Forms",
}

export const enum EditorConfigErrorType {
  System = "System.Exception",
  LinkScope = "ASC.Files.Core.Exceptions.LinkScopeException",
  NotFoundScope = "System.IO.FileNotFoundException",
  AccessDeniedScope = "System.Security.SecurityException",
  TenantQuotaException = "ASC.Core.Tenants.TenantQuotaException",
}

/**
 * Enum for watermarks.
 * @readonly
 */
export enum WatermarkAdditions {
  UserName = 1,
  UserEmail = 2,
  UserIpAdress = 4,
  CurrentDate = 8,
  RoomName = 16,
}

export const enum RoomsStorageFilter {
  internal = 1,
  thirdparty = 2,
}

export const enum VDRIndexingAction {
  HigherIndex = "HigherIndex",
  LowerIndex = "LowerIndex",
  MoveIndex = "MoveIndex",
}

export const enum LDAPOperation {
  SaveAndSync = "Save",
  Sync = "Sync",
}

export const enum LDAPCertificateProblem {
  CertExpired = -2146762495,
  CertValidityPeriodNesting = -2146762494,
  CertRole = -2146762493,
  CertPathLenConst = -2146762492,
  CertCritical = -2146762491,
  CertPurpose = -2146762490,
  CertIssuerChaining = -2146762489,
  CertMalformed = -2146762488,
  CertUntrustedRoot = -2146762487,
  CertChainnig = -2146762486,
  CertRevoked = -2146762484,
  CertUntrustedTestRoot = -2146762483,
  CertRevocationFailure = -2146762482,
  CertCnNoMatch = -2146762481,
  CertWrongUsage = -2146762480,
  CertUntrustedCa = -2146762478,
  CertUnrecognizedError = -2146762477,
}

export const enum ExportRoomIndexTaskStatus {
  Created = 0,
  Running = 1,
  Completed = 2,
  Canceled = 3,
  Failed = 4,
}

export enum FileExtensions {
  PDF = "pdf",
  DOC = "doc",
  DOCX = "docx",
  DOCXF = "docxf",
  XLSX = "xlsx",
  PPTX = "pptx",
}

export enum ValidationStatus {
  Ok = 0,
  Invalid = 1,
  Expired = 2,
  Password = 3,
  InvalidPassword = 4,
  ExternalAccessDenied = 5,
}

export enum FileFillingFormStatus {
  None = 0,
  Draft = 1,
  YourTurn = 2,
  InProgress = 3,
  Completed = 4,
  Stopped = 5,
}

export enum RoleStatus {
  Waiting = "waiting",
  YourTurn = "yourTurn",
  Filling = "filling",
  Filled = "filled",
  Stopped = "stopped",
}

export enum StartFillingMode {
  None,
  ShareToFillOut,
  StartFilling,
}

export enum FormFillingManageAction {
  Stop,
  Resume,
}

export enum FormFillingTipsState {
  Starting = 1,
  Sharing = 2,
  Submitting = 3,
  Complete = 4,
  Uploading = 5,
}

export enum FillingFormStatusHistory {
  OpenedAtDate = 0,
  SubmissionDate = 1,
  StopDate = 2,
}

export enum DeepLinkType {
  Choice = 0,
  Web = 1,
  App = 2,
}

/**
 * Enum for sort by field name
 * @readonly
 */
export const enum SortByFieldName {
  Name = "AZ",
  ModifiedDate = "DateAndTime",
  CreationDate = "DateAndTimeCreation",
  Author = "Author",
  Size = "Size",
  Type = "Type",
  Location = "Location",
  Tags = "Tags",
  RoomType = "roomType",
  LastOpened = "LastOpened",
  UsedSpace = "usedspace",
}

export enum EncryptionStatus {
  Decrypted = 0,
  EncryptionStarted = 1,
  Encrypted = 2,
  DecryptionStarted = 3,
}

/**
 * Enum for webhook triggers
 * @readonly
 */
export enum WebhookTriggers {
  All = 0,
  UserCreated = 1,
  UserInvited = 2,
  UserUpdated = 4,
  UserDeleted = 8,
  GroupCreated = 16,
  GroupUpdated = 32,
  GroupDeleted = 64,
  FileCreated = 128,
  FileUploaded = 256,
  FileUpdated = 512,
  FileTrashed = 1024,
  FileDeleted = 2048,
  FileRestored = 4096,
  FileCopied = 8192,
  FileMoved = 16384,
  FolderCreated = 32768,
  FolderUpdated = 65536,
  FolderTrashed = 131072,
  FolderDeleted = 262144,
  FolderRestored = 524288,
  FolderCopied = 1048576,
  FolderMoved = 2097152,
  RoomCreated = 4194304,
  RoomUpdated = 8388608,
  RoomArchived = 16777216,
  RoomDeleted = 33554432,
  RoomRestored = 67108864,
  RoomCopied = 134217728,
}

export enum RoomSecurityError {
  None,
  FormRoleBlockingDeletion,
}

export enum BackupStorageLocalKey {
  StorageType = "LocalCopyStorageType",
  Folder = "LocalCopyFolder",
  Storage = "LocalCopyStorage",
  ThirdPartyStorageType = "LocalCopyThirdPartyStorageType",
  ThirdPartyStorageValues = "LocalCopyThirdPartyStorageValues",
}

export enum ProvidersType {
  Box = "Box",
  DropBox = "DropBox",
  GoogleDrive = "Google Drive",
  kDrive = "kDrive",
  OneDrive = "OneDrive",
  SharePoint = "SharePoint",
  WebDav = "WebDav",
  Yandex = "Yandex",
}

export const enum InfoPanelEvents {
  showInfoPanel = "SHOW_INFO_PANEL_EVENT",
  hideInfoPanel = "HIDE_INFO_PANEL_EVENT",

  setInfoPanelSelectedRoom = "SET_INFO_PANEL_SELECTED_ROOM_EVENT",

  openShareTab = "OPEN_INFO_PANEL_SHARE_TAB_EVENT",
  openMembersTab = "OPEN_INFO_PANEL_MEMBERS_TAB_EVENT",

  setView = "SET_INFO_PANEL_VIEW_EVENT",
  setFileView = "SET_INFO_PANEL_FILE_VIEW_EVENT",
  setRoomsView = "SET_INFO_PANEL_ROOMS_VIEW_EVENT",

  setInfoPanelMobileHidden = "SET_INFO_PANEL_MOBILE_HIDDEN_EVENT",
  refreshInfoPanel = "REFRESH_INFO_PANEL_EVENT",
}

export const enum SearchArea {
  Active,
  Archive,
  Any,
  RecentByLinks,
  Templates,
  Knowledge,
  ResultStorage,
}

export const enum LinkSharingEntityType {
  RoomOrFolder = 1,
  File = 2,
}

export const enum ShareLinkType {
  Internal = 0,
  External = 1,
}

export enum VectorizationStatus {
  InProgress,
  Completed,
  Failed,
}
